import socketApi from '@/commons/webSocketCommon/socketUtil/socketContainer.js';
import common from '@/commons/webSocketCommon/mqUtils/common.js';
import HashMap from 'hashmap';
let socketInfoMap = new HashMap();
//检查websocket链接状态并自动重连
function checkWebsocket() {
    for (let socketObj of socketInfoMap.values()) {
        if (socketObj.readyState == socketObj.CLOSED) {
            socketObj.open();
        }
    }
}
setInterval(function() {
    checkWebsocket();
}, 10000);
// function yonRefresh(){
//     //解决刷新问题
//     let socketInfo = JSON.parse(sessionStorage.getItem('socketInfo'));
//     if(socketInfo !=null){
//         socketApi.initWebSocket(socketInfo);
//     }
// }
// yonRefresh();
export default {
    //初始化链接websocket
    initWebSocket(socketInfo) {
        if (!socketInfo && !socketInfo.url) {
            let returnInfo = {
                description: window.vue.$t('returnInfo.PARAMETER_ERROR'),
                ret: window.vue.$t('returnInfo.FAIL')
            };
            return returnInfo;
        }
        return socketApi.initWebSocket(socketInfo);
    },
    // 发送信息
    send(socketId, agentData, callback) {
        return socketApi.send(socketId, agentData, callback);
    },
    //订阅消息
    subscribeMessage(cmd, callback) {
        return socketApi.subscribeMessage(cmd, callback);
    },
    
    //取消订阅
    unsubscribe(msgName) {
        return socketApi.unsubscribe(msgName);
    },
    //关闭
    close(socketTd) {
        return socketApi.close(socketTd);
    }
};
